<div class="c-cms-form">
    <div class="form-flex">
        <div class="form-label"></div>
        <div class="form-value">
            <div class="form-row u-pt8">
                <div class="form-row">
                    <label class="c-form-checkbox">
                        <input type="checkbox" name={{field.fieldName}}
                               onchange="$sk.changePOLICY(this, '{{field.fieldName}}')"
                               {{field.isSelected ? 'checked' : ''}}  />
                        <span class="checkbox-icons"></span>
                        <span class="checkbox-text">
                        {{each field.privacyPolicyTitle}}
                            {{$value}}
                            {{if $index < field.privacyPolicyTitle.length - 1}}
                            <br/>
                            {{/if}}
                        {{/each}}
                        <a class="form-policy" href="{{field.privacyPolicyUrl}}" target="_blank">{{field.privacyPolicyUrlTitle}}</a>
                        </span>
                    </label>
                </div>
            </div>
            {{if field.dirty && field.invalid}}
            <div class="form-error">{{field.validationMessage}}</div>
            {{/if}}
        </div>
    </div>
</div>